import { route } from 'ziggy';
import { Ziggy } from '../plugins/ziggy';

Ziggy.url = window.location.protocol + '//' + window.location.host;

export default {
  methods: {
    route(name, params, absolute) {
      try {
        return route(name, params, absolute, Ziggy);
      } catch (e) {
        console.error(e);
        return '#';
      }
    },
    redirect: (route = null, queryParams = null) => {
      window.location.href = queryParams ?
          route + (route.indexOf('?') !== -1 ? '&' : '?') + new URLSearchParams(queryParams).toString() :
          route
    }
  },
  computed: {
    currentRouteName: () => _current_route_name,
  },
};
